import { Box } from '@chakra-ui/react';
import styled from 'styled-components';

export const ImageHover = styled.div`
  top: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  transition: all ease 0.5s;
  opacity: 0;
  background: ${({ theme }) => theme.transparent(theme.colors.secondary, 70)};
`;

export const Wrapper = styled(Box)`
  :hover {
    .image-hover {
      opacity: 1;
    }
  }
`;
